import { render, staticRenderFns } from "./PrescriptionRewardDetails.vue?vue&type=template&id=03697f69&scoped=true"
import script from "./PrescriptionRewardDetails.vue?vue&type=script&lang=js"
export * from "./PrescriptionRewardDetails.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionRewardDetails.vue?vue&type=style&index=0&id=03697f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03697f69",
  null
  
)

export default component.exports